import { createAction, handleActions } from "redux-actions";

const initialState = {
  pxPerFt: 0,
  gridVisible: false,
};

export const actionScalePxPerFtUpdated = createAction(
  "SCALE_PX_PER_FT_UPDATED",
);
export const actionScaleGridVisibleUpdated = createAction(
  "SCALE_GRID_VISIBLE_UPDATED",
);

export const scaleReducer = handleActions(
  {
    [actionScalePxPerFtUpdated]: (state, action) => {
      return {
        ...state,
        pxPerFt: action.payload.pxPerFt,
      };
    },
    [actionScaleGridVisibleUpdated]: (state, action) => {
      return {
        ...state,
        gridVisible: action.payload.gridVisible,
      };
    },
  },
  initialState,
);
